import { useTranslation } from 'react-i18next';

import { useFeature } from '@treams/treams-hooks';
import { FeatureName } from '@treams/treams-network';
import { ArrowLeftIcon, Button, DashboardIcon, HeartRateIcon, Sidebar } from '@treams/treams-ui';

import { useManagerMode } from '../ManagerModeContext';

export const EngagementOfficerItems = () => {
	const { t } = useTranslation();

	const hasEngagement = useFeature(FeatureName.Engagement);
	const managermode = useManagerMode();

	return (
		<>
			{managermode.enabled ? (
				<Button
					title={t('sidebar.manager.back')}
					type="secondary"
					icon={<ArrowLeftIcon />}
					link="/manager"
					mb={4}
				/>
			) : (
				<Button
					title={t('sidebar.user.back')}
					type="secondary"
					icon={<ArrowLeftIcon />}
					link="/"
					mb={4}
				/>
			)}
			<Sidebar.Item
				small
				exact
				icon={<DashboardIcon />}
				title={t('settings.overview.title')}
				path="/settings"
			/>
			<Sidebar.SectionTitle mt={4} mb={1}>
				{t('settings.section.content')}
			</Sidebar.SectionTitle>
			{hasEngagement && (
				<Sidebar.Item
					small
					icon={<HeartRateIcon />}
					title={t('settings.engagement.title')}
					path="/settings/engagement"
				/>
			)}
		</>
	);
};
